var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMapLocator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.724 6.40823C12.724 11.9191 6.362 16.76 6.362 16.76C6.362 16.76 0 11.9191 0 6.40823C0 2.86911 2.84841 0 6.362 0C9.87559 0 12.724 2.86911 12.724 6.40823ZM6.3627 2.95776C4.47074 2.95776 2.93701 4.50264 2.93701 6.40836C2.93701 8.31406 4.47074 9.85893 6.3627 9.85893C8.25467 9.85893 9.7884 8.31406 9.7884 6.40836C9.7884 4.50264 8.25467 2.95776 6.3627 2.95776Z",
    fill: "#68686C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapLocator);
export default __webpack_public_path__ + "static/media/icon-map-locator.9c7e81349b69bc366b50398cb5cf425f.svg";
export { ForwardRef as ReactComponent };